/** Textos específicos de las exportaciones de actividades; el componente compartido no conoce reportes. */
function activityDownloadToastCopy(item) {
  const { reportName, usersLabel, rangeLabel } = item.context || {}
  if (item.status === 'loading') {
    const progress = item.progress
    let detail = ''

    if (progress?.message) {
      detail = progress.message

      if (progress.processed_rows) {
        const processedRows = Number(progress.processed_rows).toLocaleString('es')
        detail += ` · ${processedRows} registros procesados`
      }

      detail += '. '
    }
    return {
      title: 'Descargando archivo…',
      message: `${detail}Reporte de ${reportName || item.title} de ${usersLabel || 'tus usuarios'}, ${rangeLabel || 'el periodo seleccionado'}.`
    }
  }
  if (item.status === 'empty') {
    return {
      title: 'No hay actividades en este rango',
      message:
        'Tus usuarios no registraron actividades en el periodo seleccionado. Prueba con otro rango de fechas o con más actividades. No se descargó ningún archivo.'
    }
  }
  if (item.status === 'error') {
    return {
      title: 'No pudimos descargar el archivo',
      message: item.message || 'Revisa tu conexión e intenta de nuevo.'
    }
  }
  return {
    title: 'Archivo descargado',
    message:
      item.message ||
      (item.filename
        ? 'El archivo se descargó automáticamente.'
        : 'El archivo está listo y se envió al navegador.')
  }
}

export const ACTIVITY_DOWNLOAD_TOAST_MESSAGES = {
  loading: activityDownloadToastCopy,
  empty: activityDownloadToastCopy,
  error: activityDownloadToastCopy,
  success: activityDownloadToastCopy
}
